module.exports = __webpack_public_path__ + "static/media/um.4413026d.png";